import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("craftora_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function wsURL(projectId, token) {
  const httpBase = BACKEND_URL || window.location.origin;
  const base = httpBase.replace(/^http/, "ws");
  return `${base}/api/ws/chat/${projectId}?token=${encodeURIComponent(token || "")}`;
}

// Safely turn any axios/server error into a plain string for toasts.
// Handles FastAPI/Pydantic 422 arrays of {type, loc, msg, input, ctx}.
export function errMsg(err, fallback = "Something went wrong") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d.map(e => (typeof e === "string" ? e : e?.msg || JSON.stringify(e))).join(" · ");
  }
  if (d && typeof d === "object") return d.msg || JSON.stringify(d);
  return err?.message || fallback;
}

// Format a number as Indian Rupees (₹) using en-IN grouping.
export function inr(n) {
  const num = Number(n) || 0;
  return "₹" + new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(num);
}

